// Product list: add as needed
export const products = [
  {
    slug: "styleflix",
    name: "Styleflix",
    affiliateUrl: "https://go.hotmart.com/G99818916V?ap=13ca",
    desktopPageImageUrl: "/styleflix/desktop.jpg",
    mobilePageImageUrl: "/styleflix/mobile.jpg",
    cookiesMessage:
      "Este site utiliza cookies para melhorar sua experiência. Ao continuar navegando, você concorda com nossa política de cookies.",
  },
];
